module.exports = __webpack_public_path__ + "img/moto.87bd3d27.svg";